import { FlexProps } from '.';
import * as S from './Styles';

const FlexRow = (props: FlexProps) => {
  return <S.FlexRow {...props} />;
};

export default FlexRow;
